import React, { useState, useEffect } from 'react';
import { FunctionComponent } from 'react';
import styles from './FooterComponent.module.css';
import axios from 'axios';

interface FooterComponentProps {
  onUserMessage: (message: string) => void;
  setGptResponse: React.Dispatch<React.SetStateAction<string | undefined>>;
  setTopThreeDataPlans: React.Dispatch<React.SetStateAction<any[]>>;
}


const FooterComponent: FunctionComponent<FooterComponentProps> = ({ onUserMessage, setGptResponse, setTopThreeDataPlans }) => {

  const [message, setMessage] = useState('');
  
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    if (message.trim() !== '') {
      onUserMessage(message);
      setMessage('');
  
      try {
        const response = await axios.post('https://cors-anywhere.herokuapp.com/https://8062762946.for-seoul.synctreengine.com/chatgpt', { message });
        const data = response.data;
  
        const resultsWithIds = [];
  
        for (let i = 0; i <= 83; i++) {
          const logBaseData = data.result[0][i].fields.LogBaseData;
          const logCall = data.result[0][i].fields.LogCall;
          const logDataRate = data.result[0][i].fields.LogDataRate;
          const logEffectivePrice = data.result[0][i].fields.LogEffectivePrice;
          const logSMS = data.result[0][i].fields.LogSMS;
          const messageChoices = data.result[1].response.body.choices[0].message;
          const id = data.result[0][i].id;
  
          const userPreferences = messageChoices;
  
          const result = Math.sqrt(
            Math.pow(userPreferences["월 데이터량"] - logBaseData, 2) +
            Math.pow(userPreferences["데이터 속도"] - logDataRate, 2) +
            Math.pow(userPreferences["월 통화량"] - logCall, 2) +
            Math.pow(userPreferences["월 문자량"] - logSMS, 2) +
            Math.pow(userPreferences["가격"] - logEffectivePrice, 2)
          );
  
          resultsWithIds.push({ id, result });
        }
  
        resultsWithIds.sort((a, b) => a.result - b.result);
        const topThreeIds = resultsWithIds.slice(0, 3).map(item => item.id);
  
        const topThreeDataPlans = [];
  
        for (const id of topThreeIds) {
          for (let i = 0; i < data.result[0].length; i++) {
            const matchingData = data.result[0][i];
            if (matchingData.id === id) {
              const details = {
                id: matchingData.id,
                fields: matchingData.fields, // Update this with the specific details structure you want to extract
              };
              topThreeDataPlans.push(details);
              break;
            }
          }
        }
  
        console.log('Response:', response);
        console.log('Top Three Data Plans:', topThreeDataPlans);

        // Send another POST request with top three plans and user input message
        // Send another POST request with top three plans and message history
        const response2 = await axios.post('https://cors-anywhere.herokuapp.com/https://8062762946.for-seoul.synctreengine.com/chatgpt2', JSON.stringify({
          topThreeDataPlans: JSON.stringify(topThreeDataPlans),
          messageHistory: JSON.stringify(onUserMessage)
        }), {
          headers: {
            'Content-Type': 'text/plain'
          }
        });
        const gptResponse = response2.data.result.response.body.choices[0].message.content;

        setGptResponse(gptResponse); // here is where we update the state in MacBookAir1
  


      // You can do further processing with the response from the second request here

    } catch (error) {
      console.error('Error sending message:', error);
    }
  }
};

  
  const handleTextareaResize = () => {
    const textarea = document.getElementById('messageTextarea');
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  useEffect(() => {
    handleTextareaResize();
  }, [message]);

  return (
    <footer className={styles.stopGeneratingParent}>
      <div className={styles.inputContainer}>
        <div className={styles.buttonInputContainer}>
          <textarea
            id="messageTextarea"
            className={styles.typeSection}
            rows={1}
            value={message}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onInput={handleTextareaResize}
            placeholder="원하시는 요금제 사항을 입력해주세요"
          />
        </div>
        <button className={styles.buttonsend} onClick={handleSubmit}>
          <img className={styles.send2Icon} alt="" src="/send2.svg" />
        </button>
      </div>
    </footer>
  );
};

export default FooterComponent;
